import { useState } from "react";
import { db, queue, uuid, type Contact } from "../db";
import { sync } from "../sync";
import { Shell, type ScreenProps } from "./common";

const POSITIONS = [
  "Заведующая", "Провизор / первостольник", "Врач-стоматолог",
  "Главный врач", "Администратор", "Закупщик",
];

export default function ContactForm({ updateReady, back, state, pointId }: ScreenProps & { pointId: string }) {
  const [fullName, setFullName] = useState("");
  const [position, setPosition] = useState(POSITIONS[0]);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const canSave = fullName.trim().length > 0 && consent && !busy;

  async function save() {
    if (!fullName.trim()) return setError("Укажи ФИО");
    if (!consent) return setError("Без отметки о согласии контакт сохранить нельзя");
    setBusy(true); setError(null);
    try {
      const row: Contact = {
        id: uuid(), pointId,
        fullName: fullName.trim(), position,
        phone: phone.trim() || null, email: email.trim() || null,
        consent: true, consentAt: new Date().toISOString(),
        note: note.trim() || null,
        updatedAt: new Date().toISOString(),
      };
      await db.contacts.put(row);
      await queue("contact", row.id);
      void sync();
      back();
    } catch {
      setError("Не удалось сохранить");
      setBusy(false);
    }
  }

  return (
    <Shell
      title="Новый контакт"
      onBack={back}
      state={state} updateReady={updateReady}
      footer={
        <>
          <button className="btn primary" onClick={save} disabled={!canSave}>Сохранить</button>
          <button className="btn ghost" onClick={back}>Отмена</button>
          {!consent && (
            <span className="hint" style={{ alignSelf: "center" }}>
              Отметь согласие, чтобы сохранить
            </span>
          )}
        </>
      }
    >
      {error && <div className="err">{error}</div>}

      <div className="field">
        <label className="label" htmlFor="fn">ФИО <span className="req">*</span></label>
        <input id="fn" className="inp" value={fullName}
          placeholder="Ковалёва Ирина Петровна"
          onChange={(e) => setFullName(e.target.value)} />
        <div className="hint">Хранится в базе в зашифрованном виде</div>
      </div>

      <div className="field">
        <label className="label" htmlFor="ps">Должность <span className="req">*</span></label>
        <select id="ps" className="inp" value={position} onChange={(e) => setPosition(e.target.value)}>
          {POSITIONS.map((p) => <option key={p} value={p}>{p}</option>)}
        </select>
      </div>

      <div className="row2">
        <div className="field">
          <label className="label" htmlFor="ph">Телефон</label>
          <input id="ph" className="inp" type="tel" inputMode="tel" value={phone}
            placeholder="+375 __ ___ __ __" onChange={(e) => setPhone(e.target.value)} />
        </div>
        <div className="field">
          <label className="label" htmlFor="em">Почта</label>
          <input id="em" className="inp" type="email" inputMode="email" value={email}
            placeholder="Необязательно" onChange={(e) => setEmail(e.target.value)} />
        </div>
      </div>

      <div className="field">
        <label className="label" htmlFor="nt">Комментарий</label>
        <input id="nt" className="inp" value={note}
          placeholder="Когда удобнее приходить" onChange={(e) => setNote(e.target.value)} />
      </div>

      <div className="note">
        <b>Прочитайте или покажите собеседнику:</b><br />
        «Я запишу ваше имя, должность и телефон, чтобы в следующий раз обращаться к вам
        и предупреждать о визите. Данные хранит наша компания, по вашей просьбе удалим. Хорошо?»
        <div className="hint" style={{ marginTop: 6 }}>
          Точную формулировку даёт юрист компании — это черновик.
        </div>
      </div>

      <label className="shelf" style={{ border: "1px solid var(--border)", borderRadius: 10, padding: 13 }}>
        <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} />
        <span style={{ flex: 1 }}>
          <b>Согласие получено</b> — я спросил, человек согласился
          <div className="hint">Дата и время поставятся автоматически</div>
        </span>
      </label>
    </Shell>
  );
}
